import {Button} from '@/components/ui/button/Button'
import styled, {css} from 'styled-components'

export const StyledProjectSuspensionsHistory = styled(Button)(
    ({theme: {palette}}) => css`
        font-weight: 400;
        width: 100%;
        justify-content: flex-start;
        border-radius: 0;

        color: ${palette.neutral['950']};
        & > svg {
            fill: ${palette.neutral['500']};
        }
        &[aria-disabled='true'] {
            pointer-events: none;
            color: ${palette.neutral['400']}!important;
            & > svg {
                fill: ${palette.neutral['300']}!important;
            }
        }

        &:hover {
            color: ${palette.neutral['950']};
            background-color: ${palette.neutral['100']};
        }
    `
)

export const StyledSuspensionCard = styled.div(
    ({theme: {palette, spacing, typography}}) => css`
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: ${spacing * 2}px;
        border: 1px solid ${palette.neutral[200]};
        ${typography.textMd};
        color: ${palette.neutral[600]};
        padding: ${spacing * 2}px;
    `
)

export const StyledTotalSuspensionDays = styled.h3(
    ({theme: {typography, palette}}) => css`
        ${typography.textMd};
        color: ${palette.neutral[950]};
        font-weight: 500;
    `
)
